import { render } from "./PaymentTable.vue?vue&type=template&id=393a2fe5&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"

import "./PaymentTable.vue?vue&type=style&index=0&id=393a2fe5&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393a2fe5"]])

export default __exports__